'use client'

import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from '@mui/material'
import { Search, Notifications } from '@mui/icons-material'
import Image from 'next/image'
import { IUserParent } from '@/api';
import { useEffect, useState } from 'react';

interface ProfileParentProps {
  initialData?: IUserParent;
}

export default function WaitingConfirm({
  initialData,
}: ProfileParentProps) {
  return (
    <Box sx={{ textAlign: 'center', py: 3 }}>
        <Typography color="textSecondary" sx={{ mb: 2 }}>
          Not Parent Information on your account yet. Please add your parent
        </Typography>
        <Button variant="contained" color="warning">
          Add Parent
        </Button>
      </Box>
  )
}

